import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["textColor", "backgroundColor", "isSticky", "className", "children"];
import React, { forwardRef } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
export var ApplicationLayoutBodyBanner = /*#__PURE__*/forwardRef(function (props, ref) {
  var textColor = props.textColor,
    backgroundColor = props.backgroundColor,
    isSticky = props.isSticky,
    className = props.className,
    children = props.children,
    remainingProps = _objectWithoutProperties(props, _excluded);
  var bannerClasses = classNames('ApplicationLayoutBodyBanner', textColor, backgroundColor, isSticky && 'position-sticky top-0 z-index-3', className);
  return /*#__PURE__*/React.createElement("div", _extends({}, remainingProps, {
    ref: ref,
    className: bannerClasses
  }), children);
});
ApplicationLayoutBodyBanner.defaultProps = {
  textColor: 'text-color-white',
  backgroundColor: 'bg-primary',
  isSticky: true
};
ApplicationLayoutBodyBanner.propTypes = {
  textColor: PropTypes.string,
  backgroundColor: PropTypes.string,
  isSticky: PropTypes.bool,
  className: PropTypes.string
};
export default ApplicationLayoutBodyBanner;